import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "chat-bubble flex w-full space-x-3 max-w-[90%]" }
const _hoisted_2 = { class: "space-y-0.5" }
const _hoisted_3 = {
  key: 0,
  class: "text-primary-faded text-xs"
}
const _hoisted_4 = { class: "chat-bubble-agent py-2 px-3 rounded-md leading-5 text-md" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatBubbleAgent',
  props: {
  showAvatar: {
    type: Boolean,
    required: false
  },

  showName: {
    type: Boolean,
    required: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showAvatar)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["chat-bubble-agent flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center", {
        'mt-4': __props.showName
      }])
        }, [
          _renderSlot(_ctx.$slots, "initials")
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (__props.showName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "name")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})